import * as biLogger from 'public/biLogger'
import wixWindow from 'wix-window';

import { goToNextPage } from 'public/utils'
import wixLocation from 'wix-location';

$w.onReady(function () {
    if (wixWindow.rendering.env === "browser") {
        pageEvents();
    }

});

const setTrackingForSectionImageClicks = (idArray, sectionName) => {
    idArray.forEach((imgId) => {
        const image = $w(imgId);

        image.onClick(() => {
            biLogger.clickOnCta({
                ctaName: image.id,
                section: sectionName,
                pageName: 'main_page',
                targetUrl: image.link
            })
        })
    });
}
const setTrackingForSectionButtonClicks = (idArray, sectionName) => {
    idArray.forEach((buttonId) => {
        const btn = $w(buttonId)
        btn.onClick(() => {
            biLogger.clickOnCta({
                ctaName: btn.label,
                section: sectionName,
                pageName: 'main_page',
                targetUrl: btn.link
            })
        })
    })
}

async function pageEvents() {
    $w('#input1').focus();
    $w('#generateNameButton').onClick(() => {
        let keyword = $w('#input1').value;
        /** @type {Industry} */
        let industry = $w('#categorySearch').value;
        biLogger.generateName({
            keyword,
            industry: industry?.value ?? '',
            mainCategory: industry?.postRegVertical ?? '',
            pageName: 'main_page'
        });
        goToNextPage(keyword, industry);
    });
    $w('#input1').onKeyPress(async (e) => {
        if (e.key === 'Enter') {
            let keyword = $w('#input1').value;
            let industry = $w('#categorySearch').value;

            goToNextPage(keyword, industry);
        }
    });

    $w('#input1').onInput((e) => {
        biLogger.keywordTyped({
            pageName: 'main_page',
            query: e.target.value
        });
    });

    $w('#categorySearch').onIndustrySelected(
        /** @param {Industry} industry } */
        (industry) => {
            $w('#categorySearch').value = industry;
        }
    )

    $w('#industryPages').children.forEach(node => {
        node.onClick(() => {
            const targetUrl = `${wixLocation.url}${node.link}`;

            biLogger.clickOnCta({ pageName: 'main_page', section: 'firstFold', ctaName: node.label, targetUrl })
        });
    });

    setTrackingForSectionImageClicks(['#websiteCreation', '#domainPicture', '#logoPicture'], 'secondFold')
    setTrackingForSectionButtonClicks(['#ctaWebsite', '#ctaDomain', '#ctaLogo'], 'secondFold')

    const thirdFoldLinks = ['#tips', '#howToChoose', '#howToRegister']
    setTrackingForSectionButtonClicks(thirdFoldLinks, 'secondFold')

    $w('#buttonCloser').onClick((e) => {
        biLogger.clickOnCta({
            ctaName: 'buttonCloser-startNow',
            section: 'footer',
            pageName: 'main_page',
            targetUrl: $w('#buttonCloser').link
        });
        wixLocation.to($w('#buttonCloser').link);
    })

}

/**
 * @typedef {Object} Industry
 * @property {string} value
 * @property {string} industryId
 * @property {string} structureId
 * @property {string} postRegVertical 
 */